import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexView from '@/views/IndexView'
import TestMain from '@/views/Test/Main'
import WaterfallFlow from '@/components/Layout/WaterfallFlow'
import TestWaterfallFlow from '@/views/Test/WaterfallMain'
import Main from '@/views/Index/Main'
import LoginView from '@/views/LoginView'
import RegisterView from '@/views/RegisterView'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { guest: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView,
    meta: { guest: true }
  },
  {
    path: '/',
    name: 'IndexView',
    component: IndexView,
    meta: { requiresAuth: true }
  },
  {
    path: '/v2',
    name: 'Main',
    component: Main,
    meta: { requiresAuth: true }
  },
  {
    path: '/test',
    name: 'Test',
    component: TestMain,
    meta: { requiresAuth: true }
  },
  {
    path: '/waterfall',
    name: 'Waterfall',
    component: WaterfallFlow,
    meta: { requiresAuth: true }
  },
  {
    path: '/testWaterfall',
    name: 'TestWaterfallFlow',
    component: TestWaterfallFlow,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  // 如果路由需要认证且用户未登录，重定向到登录页
  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else if (to.meta.guest && token) {
    // 如果路由是访客路由且用户已登录，重定向到首页
    next('/')
  } else {
    next()
  }
})

export default router
